/**
 * Canonical form for the tenant key (a workspace's `website`).
 *
 * Mirrors `backend/api/utils/domain.py::normalize_website`. The backend
 * normalizes too and is authoritative — this exists so the user sees the value
 * they'll actually get before submitting, not to be the enforcement point.
 *
 * Strips scheme, userinfo, port, path/query/fragment and a leading `www.`:
 *   http://Www.CSL-STL.com/contact?x=1  ->  csl-stl.com
 */
export function normalizeWebsite(value: string | null | undefined): string {
  let raw = (value ?? '').trim().toLowerCase();
  if (!raw) return '';

  // Scheme only counts at the START — an embedded "://" (e.g. in a ?next= param)
  // must not be treated as one. Mirrors _SCHEME_RE in api/utils/domain.py.
  raw = raw.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
  raw = raw.split('/')[0].split('?')[0].split('#')[0]; // path/query/fragment
  raw = raw.split('@').pop() ?? ''; // userinfo
  raw = raw.split(':')[0]; // port
  raw = raw.replace(/^\.+|\.+$/g, '');

  // A bracket means a malformed IPv6 literal (e.g. "http://[bad"). Python's
  // urlparse raises on these and we treat them as "not a domain"; match that,
  // rather than emitting a nonsense value the backend would then reject.
  if (raw.includes('[') || raw.includes(']')) return '';

  if (raw.startsWith('www.')) raw = raw.slice(4);
  return raw;
}
